import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreateMeterModelsArg, CreateMeterModelsResult } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useCreateMeterModel = (): UseMutationResult<CreateMeterModelsResult, unknown, CreateMeterModelsArg> => {
  const queryClient = useQueryClient();
  const { meterModelsApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.meterModels.create(),
    mutationFn: async (arg: CreateMeterModelsArg) => await meterModelsApiClient.create(arg),
    onError: error => {
      notify.error({
        message: 'There was an error while creating meter model',
        description: error instanceof Error ? getErrorMessage(error) : undefined,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.meterModels.all());
      notify.success({
        message: `Meter model created`,
      });
    },
  });
};
